var render = function (_h,_vm) {var _c=_vm._c;return _c('label',{class:[_vm.$style.formLabel, _vm.props.small && _vm.$style.small],attrs:{"for":_vm.props.for}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }